/**
 * 场景区域（scene_inspection.region）值域 → 中文展示名。
 *
 * 值由后端 case_flow_service.create_scene 落库时按 record_address 里的 Azure
 * account host 派生（cn=国内 BOS 数据 / ae=阿联酋 uaemap / sea=新加坡 seamap），
 * 非 case-flow 来源一律 cn，创建后不更新。
 *
 * 三套 case-flow cluster 数据互不相通，因此「区域」不只是展示字段：
 * 任务列表按它收窄查询、apiCode 跳 case-flow（waypulse）也按它选域名
 * （见 @components/ApiCodeLink）。后端值域白名单同源：
 * simulation_platform/services/task_service.py 的 _REGION_WHITELIST。
 */

/** 区域英文值 → 中文名；未登记的英文值原样展示（防漏映射，与 sceneGroup 同风格）。 */
export const SCENE_REGION_LABELS: Record<string, string> = {
  cn: '国内',
  ae: '阿联酋',
  sea: '新加坡',
};

/** 区域下拉候选（筛选表单用）。顺序 = 国内优先，与用户习惯一致。 */
export const SCENE_REGION_OPTIONS: { value: string; label: string }[] = [
  { value: 'cn', label: '国内' },
  { value: 'ae', label: '阿联酋' },
  { value: 'sea', label: '新加坡' },
];

/** 值域白名单 —— URL 参数解码时用它过滤非法项（与后端 fail-fast 同一份值域）。 */
export const SCENE_REGION_VALUES = ['cn', 'ae', 'sea'] as const;

export type SceneRegion = (typeof SCENE_REGION_VALUES)[number];

/** 英文值 → 中文展示；空值返回 null（调用方自行决定占位符），未映射的原样返回。 */
export function sceneRegionDisplay(region: string | null | undefined): string | null {
  const key = (region || '').trim().toLowerCase();
  if (!key) return null;
  return SCENE_REGION_LABELS[key] ?? region ?? null;
}